import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: () => ({
    works: [],
    allWorksLoaded: false,
    meta: null,
    page: 1,
    work: null,
    noResult: false,
  }),
  actions,
  getters,
  mutations,
};
